export default __webpack_public_path__ + "static/media/O.e85fcbe3.svg";